export default __webpack_public_path__ + "static/media/Photo 11 - BR - ombrelle.39724add.jpg";